import styled from 'styled-components'
import * as stylesConstants from '../../../../assets/constants/ui'

const Bound = styled.div`
    display: flex;
    flex: 1;
    padding-top: ${stylesConstants.HEADER_HEIGHT}px;
`

export { Bound }